module.exports = __webpack_public_path__ + "img/LIANG SHE HAN BUY GOOD.dcb2934e.svg";